import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ONE_WAY_IN_BASE_ROUTE } from 'src/navigation';

import Opportunity from './pages/Opportunity';
import ActivityLog from './pages/ActivityLog';
import Archiving from './pages/Archiving';
import Reopening from './pages/Reopening';
import Referring from './pages/Referrering';
import ProgramAdmission from './pages/ProgramAdmission';
import Services from './pages/Services';
import CompanyInfo from './pages/CompanyInfo';
import CustomerCommunication from './pages/CustomerCommunication';
import EmailLog from './pages/EmailLog';
import AddNote from './components/add-note/AddNote';
import { useAuth } from 'src/features/authorization';
import OldOpportunity from './pages/OldOpportunity';
import OldActivityLog from './pages/OldActivityLog';
import OldServices from './pages/OldServices';
import OldEmailLog from './pages/OldEmailLog';
import OldCustomerCommunication from './pages/OldCustomerCommunication';
import OldCompanyInfo from './pages/OldCompanyInfo';
import OpportunityOverview from './pages/OpportunityOverview';

const ONE_WAY_IN_DETAILS_BASE = 'details';
const ONE_WAY_IN_DETAILS_INQUIRY = 'inquiry';
const ONE_WAY_IN_DETAILS_ACTIVITY_LOG = 'activityLog';
const ONE_WAY_IN_DETAILS_NOTE = 'note';
const ONE_WAY_IN_DETAILS_REFERRER = 'referrer';
const ONE_WAY_IN_DETAILS_ARCHIVING = 'archiving';
const ONE_WAY_IN_DETAILS_REOPENING = 'reopening';
const ONE_WAY_IN_DETAILS_PROGRAM_ADMISSION = 'programAdmission';
const ONE_WAY_IN_DETAILS_SERVICES = 'services';
const ONE_WAY_IN_DETAILS_ADD_NOTE = 'addNote';
const ONE_WAY_IN_DETAILS_COMPANY_INFO = 'companyInfo';
const ONE_WAY_IN_CUSTOMER_COMMUNICATION = 'customerCommunication';

export const ONE_WAY_IN_DETAILS = {
  BASE: (formId: string) => `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}` as const,
  INQUIRY: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_INQUIRY}` as const,
  ACTIVITY_LOG: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_ACTIVITY_LOG}` as const,
  NOTE: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_NOTE}` as const,
  REFERRER: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_REFERRER}` as const,
  ARCHIVING: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_ARCHIVING}` as const,
  REPOPENING: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_REOPENING}` as const,
  PROGRAM_ADMISSION: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_PROGRAM_ADMISSION}` as const,
  SERVICES: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_SERVICES}` as const,
  ADD_NOTE: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_ADD_NOTE}` as const,
  COMPANY_INFO: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_DETAILS_COMPANY_INFO}` as const,
  CUSTOMER_COMMUNICATION: (formId: string) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_CUSTOMER_COMMUNICATION}` as const,
  CUSTOMER_COMMUNICATION_THREAD: (formId: string, threadId: number) =>
    `${ONE_WAY_IN_BASE_ROUTE}/${ONE_WAY_IN_DETAILS_BASE}/${formId}/${ONE_WAY_IN_CUSTOMER_COMMUNICATION}/${threadId}` as const,
};

type FFSwitchProps = {
  newComponent: React.ComponentType;
  oldComponent: React.ComponentType;
};
const FFSwitch: React.FC<FFSwitchProps> = ({ newComponent: New, oldComponent: Old }) =>
  useAuth().checkAccess('FF_NewOpportunityDetails').read ? <New /> : <Old />;

const NavigateToBase: React.FC = () => <Navigate to="" replace />;

const routes: RouteObject[] = [
  {
    path: ``,
    element: <FFSwitch oldComponent={OldOpportunity} newComponent={OpportunityOverview} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_INQUIRY}`,
    element: <FFSwitch oldComponent={NavigateToBase} newComponent={Opportunity} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_ACTIVITY_LOG}`,
    element: <FFSwitch oldComponent={OldActivityLog} newComponent={ActivityLog} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_REFERRER}`,
    element: <FFSwitch oldComponent={Referring} newComponent={NavigateToBase} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_ARCHIVING}`,
    element: <FFSwitch oldComponent={Archiving} newComponent={NavigateToBase} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_REOPENING}`,
    element: <FFSwitch oldComponent={Reopening} newComponent={NavigateToBase} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_PROGRAM_ADMISSION}`,
    element: <FFSwitch oldComponent={ProgramAdmission} newComponent={NavigateToBase} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_SERVICES}`,
    element: <FFSwitch oldComponent={OldServices} newComponent={Services} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_ADD_NOTE}`,
    element: <FFSwitch oldComponent={AddNote} newComponent={NavigateToBase} />,
  },
  {
    path: `${ONE_WAY_IN_DETAILS_COMPANY_INFO}`,
    element: <FFSwitch oldComponent={OldCompanyInfo} newComponent={CompanyInfo} />,
  },
  {
    path: `${ONE_WAY_IN_CUSTOMER_COMMUNICATION}`,
    element: <FFSwitch oldComponent={OldCustomerCommunication} newComponent={CustomerCommunication} />,
  },
  {
    path: `${ONE_WAY_IN_CUSTOMER_COMMUNICATION}/:threadId`,
    element: <FFSwitch oldComponent={OldEmailLog} newComponent={EmailLog} />,
  },
  {
    path: `*`,
    element: <Navigate to="" replace />,
  },
];

export default routes;
